import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../resources/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2c152aaa from 'nuxt_plugin_plugin_2c152aaa' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_portalvue_56c2aeb2 from 'nuxt_plugin_portalvue_56c2aeb2' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_libplugin35091147_eea11f12 from 'nuxt_plugin_libplugin35091147_eea11f12' // Source: ./lib.plugin.35091147.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_7f3d686c from 'nuxt_plugin_nuxtuseragent_7f3d686c' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_3a5bbc1f from 'nuxt_plugin_nuxtsvgsprite_3a5bbc1f' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_templatesplugin2a4f6aa8_4881652e from 'nuxt_plugin_templatesplugin2a4f6aa8_4881652e' // Source: ./templates.plugin.2a4f6aa8.js (mode: 'client')
import nuxt_plugin_nuxtcookiecontrol_01d56eb9 from 'nuxt_plugin_nuxtcookiecontrol_01d56eb9' // Source: ./nuxt-cookie-control.js (mode: 'all')
import nuxt_plugin_axios_758c037e from 'nuxt_plugin_axios_758c037e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_router_d35b54e4 from 'nuxt_plugin_router_d35b54e4' // Source: ./router.js (mode: 'all')
import nuxt_plugin_eventbus_2faefc80 from 'nuxt_plugin_eventbus_2faefc80' // Source: ../resources/plugins/event-bus.js (mode: 'all')
import nuxt_plugin_windowwidth_09394d78 from 'nuxt_plugin_windowwidth_09394d78' // Source: ../resources/plugins/window-width.js (mode: 'all')
import nuxt_plugin_localiseurl_0b2d69a2 from 'nuxt_plugin_localiseurl_0b2d69a2' // Source: ../resources/plugins/localise-url.js (mode: 'all')
import nuxt_plugin_intersectionobserverpolyfill_3c8ca9d0 from 'nuxt_plugin_intersectionobserverpolyfill_3c8ca9d0' // Source: ../resources/plugins/intersection-observer-polyfill (mode: 'client')
import nuxt_plugin_polyfills_7dce8c4e from 'nuxt_plugin_polyfills_7dce8c4e' // Source: ../resources/plugins/polyfills (mode: 'client')
import nuxt_plugin_freezebodyscroll_555be918 from 'nuxt_plugin_freezebodyscroll_555be918' // Source: ../resources/plugins/freeze-body-scroll (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../resources/plugins/api (mode: 'all')
import nuxt_plugin_touch_335704ee from 'nuxt_plugin_touch_335704ee' // Source: ../resources/plugins/touch (mode: 'client')
import nuxt_plugin_popover_615cdb22 from 'nuxt_plugin_popover_615cdb22' // Source: ../resources/plugins/popover (mode: 'client')
import nuxt_plugin_tagsinput_4b5c290c from 'nuxt_plugin_tagsinput_4b5c290c' // Source: ../resources/plugins/tags-input (mode: 'client')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249' // Source: ../resources/plugins/gtag (mode: 'client')
import nuxt_plugin_rafloop_1d5627e0 from 'nuxt_plugin_rafloop_1d5627e0' // Source: ../resources/plugins/raf-loop (mode: 'all')
import nuxt_plugin_scrollto_ee90aa76 from 'nuxt_plugin_scrollto_ee90aa76' // Source: ../resources/plugins/scroll-to (mode: 'all')
import nuxt_plugin_scrolltoplistener_030e7df6 from 'nuxt_plugin_scrolltoplistener_030e7df6' // Source: ../resources/plugins/scroll-top-listener (mode: 'all')
import nuxt_plugin_vue2filters_60d05d10 from 'nuxt_plugin_vue2filters_60d05d10' // Source: ../resources/plugins/vue2-filters (mode: 'all')
import nuxt_plugin_openmodal_5de69560 from 'nuxt_plugin_openmodal_5de69560' // Source: ../resources/plugins/open-modal (mode: 'all')
import nuxt_plugin_safaribottom_79013962 from 'nuxt_plugin_safaribottom_79013962' // Source: ../resources/plugins/safari-bottom (mode: 'all')
import nuxt_plugin_smoothscrollanchor_3973984c from 'nuxt_plugin_smoothscrollanchor_3973984c' // Source: ../resources/plugins/smooth-scroll-anchor (mode: 'all')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../resources/plugins/jsonld (mode: 'all')
import nuxt_plugin_vuetify_165b1c58 from 'nuxt_plugin_vuetify_165b1c58' // Source: ../resources/plugins/vuetify (mode: 'all')
import nuxt_plugin_vuefbcustomerchat_0b9d4ea4 from 'nuxt_plugin_vuefbcustomerchat_0b9d4ea4' // Source: ../resources/plugins/vue-fb-customer-chat.js (mode: 'client')
import nuxt_plugin_plugin_6000d286 from 'nuxt_plugin_plugin_6000d286' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$humble', {
  get() {
    return this.$root.$options.$humble
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | el-translations","title":"el-translations","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"google","content":"notranslate"}],"htmlAttrs":{"translate":"no"},"link":[{"rel":"preconnect","crossorigin":true,"href":"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js"},{"rel":"dns-prefetch","crossorigin":true,"href":"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js"},{"rel":"preload","as":"script","href":"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Ffbevents.js"}],"script":[{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgsap\u002F2.1.2\u002FTweenLite.min.js","defer":true},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgsap\u002F2.1.2\u002FTimelineLite.min.js","defer":true},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgsap\u002F2.1.2\u002Feasing\u002FEasePack.min.js","defer":true},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgsap\u002F2.1.2\u002Fplugins\u002FCSSPlugin.min.js","defer":true},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgsap\u002F2.1.2\u002Fplugins\u002FAttrPlugin.min.js","defer":true},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fgsap\u002F2.1.2\u002Fplugins\u002FBezierPlugin.min.js","defer":true},{"hid":"webp","innerHTML":"var i=new Image;i.onload=i.onerror=function (){document.documentElement.classList.add(i.height==1?\"webp\":\"no-webp\"); window.supportsWebp = (i.height==1); };i.src=\"data:image\u002Fwebp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==\";\n\t\t\t\t","type":"application\u002Fjavascript"}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__humble_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__HUMBLE__ && window.__HUMBLE__.state) {
      store.replaceState(window.__HUMBLE__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2c152aaa === 'function') {
    await nuxt_plugin_plugin_2c152aaa(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_56c2aeb2 === 'function') {
    await nuxt_plugin_portalvue_56c2aeb2(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin35091147_eea11f12 === 'function') {
    await nuxt_plugin_libplugin35091147_eea11f12(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_7f3d686c === 'function') {
    await nuxt_plugin_nuxtuseragent_7f3d686c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_3a5bbc1f === 'function') {
    await nuxt_plugin_nuxtsvgsprite_3a5bbc1f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin2a4f6aa8_4881652e === 'function') {
    await nuxt_plugin_templatesplugin2a4f6aa8_4881652e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtcookiecontrol_01d56eb9 === 'function') {
    await nuxt_plugin_nuxtcookiecontrol_01d56eb9(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_758c037e === 'function') {
    await nuxt_plugin_axios_758c037e(app.context, inject)
  }

  if (typeof nuxt_plugin_router_d35b54e4 === 'function') {
    await nuxt_plugin_router_d35b54e4(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_2faefc80 === 'function') {
    await nuxt_plugin_eventbus_2faefc80(app.context, inject)
  }

  if (typeof nuxt_plugin_windowwidth_09394d78 === 'function') {
    await nuxt_plugin_windowwidth_09394d78(app.context, inject)
  }

  if (typeof nuxt_plugin_localiseurl_0b2d69a2 === 'function') {
    await nuxt_plugin_localiseurl_0b2d69a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intersectionobserverpolyfill_3c8ca9d0 === 'function') {
    await nuxt_plugin_intersectionobserverpolyfill_3c8ca9d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_7dce8c4e === 'function') {
    await nuxt_plugin_polyfills_7dce8c4e(app.context, inject)
  }

  if (typeof nuxt_plugin_freezebodyscroll_555be918 === 'function') {
    await nuxt_plugin_freezebodyscroll_555be918(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_touch_335704ee === 'function') {
    await nuxt_plugin_touch_335704ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_popover_615cdb22 === 'function') {
    await nuxt_plugin_popover_615cdb22(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tagsinput_4b5c290c === 'function') {
    await nuxt_plugin_tagsinput_4b5c290c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_6a810249 === 'function') {
    await nuxt_plugin_gtag_6a810249(app.context, inject)
  }

  if (typeof nuxt_plugin_rafloop_1d5627e0 === 'function') {
    await nuxt_plugin_rafloop_1d5627e0(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollto_ee90aa76 === 'function') {
    await nuxt_plugin_scrollto_ee90aa76(app.context, inject)
  }

  if (typeof nuxt_plugin_scrolltoplistener_030e7df6 === 'function') {
    await nuxt_plugin_scrolltoplistener_030e7df6(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2filters_60d05d10 === 'function') {
    await nuxt_plugin_vue2filters_60d05d10(app.context, inject)
  }

  if (typeof nuxt_plugin_openmodal_5de69560 === 'function') {
    await nuxt_plugin_openmodal_5de69560(app.context, inject)
  }

  if (typeof nuxt_plugin_safaribottom_79013962 === 'function') {
    await nuxt_plugin_safaribottom_79013962(app.context, inject)
  }

  if (typeof nuxt_plugin_smoothscrollanchor_3973984c === 'function') {
    await nuxt_plugin_smoothscrollanchor_3973984c(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_165b1c58 === 'function') {
    await nuxt_plugin_vuetify_165b1c58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuefbcustomerchat_0b9d4ea4 === 'function') {
    await nuxt_plugin_vuefbcustomerchat_0b9d4ea4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_6000d286 === 'function') {
    await nuxt_plugin_plugin_6000d286(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
